import { drawerAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { BACKGROUND_COLORS } from '../tokens';
import { resolveColor } from '../utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(drawerAnatomy.keys);

// Exports
export const Drawer = defineMultiStyleConfig({
  baseStyle: definePartsStyle((props) => ({
    dialog: {
      backgroundColor: resolveColor(props, BACKGROUND_COLORS.white.base),
    },
  })),
});
